import * as React from "react";
import { Facebook, Instagram, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
const exploreLinks = [{
  label: "Home",
  to: "/HomePage"
}, {
  label: "About Us",
  to: "#"
}, {
  label: "Top Activities",
  to: "#"
}, {
  label: "Our Services",
  to: "#"
}];
const infoLinks = [{
  label: "Privacy Policy",
  to: "#"
}, {
  label: "Terms & Conditions",
  to: "#"
}, {
  label: "Contact Us",
  to: "#"
}];
const socialLinks = [{
  icon: Instagram,
  to: "#",
  label: "Instagram"
}, {
  icon: Facebook,
  to: "#",
  label: "Facebook"
}, {
  icon: Twitter,
  to: "#",
  label: "Twitter"
}];
export default function Footer() {
  return <section id="footer" className="dark bg-background text-foreground py-16 px-6 md:px-8 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/HomePage" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591494/img/bahamas_activities_center_logo_white.png" alt="BahamaVista" className="h-7 w-auto" />
            </Link>
            <p className="text-foreground/70 max-w-xs text-sm leading-relaxed">
              The official digital gateway for Bahamas Activities Center, highlighting elite island excursions and authentic Bahamian hospitality.
            </p>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-lg font-semibold tracking-wide text-foreground">
              Explore
            </h3>
            <ul className="flex flex-col space-y-3">
              {exploreLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.to} className="text-foreground/80 hover:text-chart-3 text-sm transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-lg font-semibold tracking-wide text-foreground">
              Information
            </h3>
            <ul className="flex flex-col space-y-3">
              {infoLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.to} className="text-foreground/80 hover:text-chart-3 text-sm transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-lg font-semibold tracking-wide text-foreground">
              Follow Us
            </h3>
            <div className="flex flex-wrap gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.to} data-index={i} className="bg-foreground text-background hover:bg-chart-3 flex h-10 w-10 items-center justify-center rounded-full transition-colors duration-300" aria-label={social.label}>
                    <Icon className="h-5 w-5" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 flex flex-col items-center justify-between space-y-4 pt-8 md:flex-row md:space-y-0 border-t border-border/20">
          <p className="text-foreground/40 text-sm">
            &copy; {new Date().getFullYear()} BahamaVista. All rights reserved.
          </p>
          <p className="text-foreground/40 text-sm tracking-wider uppercase">
            Made in the Bahamas
          </p>
        </div>
      </div>
    </section>;
}